import { render, staticRenderFns } from "./Tva.vue?vue&type=template&id=6a2686ef&"
import script from "./Tva.vue?vue&type=script&lang=ts&"
export * from "./Tva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports